export default __webpack_public_path__ + "static/media/about-team-jackie-rabec.cf724e23.png";